import { createContext, useContext } from 'react';
import type { PageRouteKey } from '../types/pageInstruction';

export interface ActivePageInstructionContextValue {
  pageRouteKey: PageRouteKey | string;
  programId?: string | null;
}

const PageInstructionRenderContext = createContext<ActivePageInstructionContextValue | null>(null);

export function PageInstructionRenderProvider({
  value,
  children,
}: {
  value: ActivePageInstructionContextValue | null;
  children: React.ReactNode;
}) {
  return (
    <PageInstructionRenderContext.Provider value={value}>
      {children}
    </PageInstructionRenderContext.Provider>
  );
}

export function useActivePageInstructionContext() {
  return useContext(PageInstructionRenderContext);
}
